import React from 'react';
import { useForm } from 'react-hook-form';
import { Button, Flex, Text } from '@chakra-ui/react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';
import { useFormValidationToast } from '../../../services/actionToast';
import { useAuth } from '../../../providers/auth';
import { InputForm } from '../../inputs/forms/InputForm';
import { FormButton } from '../../buttons/FormButton';
import { PasswordInputForm } from '../../inputs/forms/PasswordInputForm';

export default function HookForm() {
  const validationToast = useFormValidationToast();
  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs = [
    {
      name: 'username',
      value: process.env.NODE_ENV === 'development' ? 'adminuser@thinkidea.app' : '',
      placeholder: 'Digite o usuário',
      label: 'Usuário',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'password',
      value: process.env.NODE_ENV === 'development' ? '123456' : '',
      placeholder: 'Digite a senha',
      label: 'Senha',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });
  const schema = Yup.object().shape(yupschema);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValuesSchema,
  });

  const username = formInputs.find((field) => field.name === 'username');
  const password = formInputs.find((field) => field.name === 'password');

  const { Login } = useAuth();

  const onSubmit = async (values: any) => {
    // eslint-disable-next-line no-alert
    await Login(values);
  };
  const navigate = useNavigate();

  return (
    <Flex
      as="form"
      direction="column"
      gap="16px"
      onSubmit={handleSubmit(onSubmit, validationToast)}
    >
      <InputForm
        name={username?.name}
        label={username?.label}
        placeholder={username?.placeholder}
        register={register}
        errors={errors}
      />

      <PasswordInputForm
        name={password?.name}
        label={password?.label}
        placeholder={password?.placeholder}
        register={register}
        errors={errors}
      />
      <FormButton mt="8px" isLoading={isSubmitting} type="submit" w="100%">
        Entrar
      </FormButton>
      <Flex justify="center" align="center" gap="4px">
        <Text fontSize="13px" color="content.body">
          Esqueceu sua senha?
        </Text>
        <Button variant="link" size="sm" onClick={() => navigate('/recover')}>
          Recuperar
        </Button>
      </Flex>
    </Flex>
  );
}
